export const getEnvVariable = (
  name: string,
  defaultValue?: string
): string | undefined => process.env[name] || defaultValue;
